
































































































import { TableHeaderFilterGrouped, TableHeaderFilters } from "@/models/general";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TableHeaderFilter extends Vue {
  @Prop({ default: () => [] }) data!: TableHeaderFilters[];
  @Prop({ default: () => [] }) groupedData!: TableHeaderFilterGrouped[];

  activeFilters: string[] = [];
  menu = false;

  selectAll(): void {
    this.activeFilters = [];
    this.data.forEach((d) => this.activeFilters.push(d.id));
    this.groupedData.forEach((gd) =>
      gd.filter.forEach((f) => this.activeFilters.push(f.id))
    );
  }

  clear(): void {
    this.activeFilters = [];
  }

  apply(): void {
    this.menu = false;
    this.$emit("onFilterChange", this.activeFilters);
  }
}
